import { GROUP_GROUP } from '../../constants/endpoints';
import request from './request';

const editGroup = async (accessToken, patch, groupId) => {
  const config = {
    method: 'patch',
    url: GROUP_GROUP(groupId),
    data: { group: patch },
  };

  const response = await request(accessToken, config);
  return response.data;
};

export default editGroup;
